module.exports = __webpack_public_path__ + "static/img/10.2465129.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/eng/10.png
// module id = WZPk
// module chunks = 0